import { request } from '@/api/request'
import GlobalConfig from '@/global/config'

const checkResponse = res => {
  return new Promise((resolve, reject) => {
    if (res.status >= 200 && res.status < 300) {
      resolve(res.data)
    }
    reject(res.data)
  })
}

// 获取公司信息
export function getCompanyData() {
  return request({
    url: `/api/company/info/${GlobalConfig.getCompanyId()}?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get'
  }).then(checkResponse)
}

// 修改公司信息
export function setCompanyData(data) {
  return request({
    url: `/api/company/modify?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'put',
    data
  }).then(checkResponse)
}

// 购买版本，会员累积有效时间展示
export function getCompanyMemberByCompanyIdApi() {
  return request({
    url: `/api/answer/admin/memberUser/queryCompanyMemberByCompanyId?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get',
  })
}

// 获取企业配置信息
export function getCompanyInfo() {
  return request({
    url: `/api/company/infoReplace/${GlobalConfig.getCompanyId()}?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get',
  }).then(checkResponse)
};

export function getSysConfig(data) {
  return request({
    url: `/api/wenjuan/admin/sysConfig/getSysConfig`,
    method: 'post',
    data
  }).then(checkResponse)
};
